module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "Work",
      "toolbar": "",
      "fixed-footer": ""
    }
  }, [_c('v-toolbar', {
    staticClass: "indigo",
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [_c('v-toolbar-title', {
    staticStyle: {
      "{cursor": "hand}"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.loadList()
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.loadList()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("home")])], 1), _vm._v("\n      " + _vm._s(_vm.$t("message.title")) + "                \n    ")], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "primary body-2",
    attrs: {
      "outline": "",
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showDialog = !_vm.showDialog
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t("message.income")) + ": " + _vm._s(_vm.$n(_vm.settings.hourlyIncome, 'currency')) + "\n    ")])], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "indigo",
    attrs: {
      "fixed": "",
      "absolute": "",
      "text-xs-center": ""
    }
  }, [_c('span', {
    staticClass: "white--text"
  }, [_vm._v("Made with ♥ in Berlin")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.setLocale('es-ES')
      }
    }
  }, [_c('img', {
    staticClass: "flag flag-es"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.setLocale('en-US')
      }
    }
  }, [_c('img', {
    staticClass: "flag flag-us"
  })]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.setLocale('de-DE')
      }
    }
  }, [_c('img', {
    staticClass: "flag flag-de"
  })])], 1), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.showDialog),
      callback: function($$v) {
        _vm.showDialog = $$v
      },
      expression: "showDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("message.setincome.title")) + "\n          "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        _vm.cancel()
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "label": _vm.$t('message.setincome.label'),
      "type": "number"
    },
    model: {
      value: (_vm.settings.hourlyIncome),
      callback: function($$v) {
        _vm.settings.hourlyIncome = $$v
      },
      expression: "settings.hourlyIncome"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "success": ""
    },
    on: {
      "click": function($event) {
        _vm.saveIncome()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "dark": ""
    }
  }, [_vm._v("save")]), _vm._v("\n          " + _vm._s(_vm.$t("message.buttons.save")) + "\n        ")], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21e86ec7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 234
// module chunks = 1